import { Link } from 'react-router-dom';

const Footer = () => {

    const date = new Date();
    return ( 
        <div>
        <div className="section techwix-cta-section-02">
            <div className="container">
                <div className="cta-wrap" style={{backgroundImage: "url(assets/images/bg/cta-bg.jpg)"}}>
                    <div className="row align-items-center">
                        <div className="col-xl-9 col-lg-8">
                            <div className="cta-content">
                                <div className="cta-icon">
                                    <img src="assets/images/cta-icon2.png" alt="" />
                                </div>
                                <p>We’re Delivering the best customer Experience</p>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4">
                            <div className="cta-btn">
                                <a className="btn btn-white" href="tel:+2349038224320">Give us a Call</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div className="section footer-section footer-section-03" style={{backgroundImage: "url(assets/images/bg/footer-bg.jpg)"}}>

            <div className="container">
                <div className="footer-widget-wrap">
                    <div className="row" style={{textAlign: "left"}}>
                        <div className="col-lg-6 col-sm-9">
                            <div className="footer-widget-about">
                                <Link className="footer-logo" to="/"><img src="assets/images/logo-white.png" alt="Logo" /></Link>
                                <p>We Drive innovation with top-tier tech teams. We have team of exceptional skills-set for your software development requirements, including cloud, infrastructure, and network solutions. Our primary goal is to understand your business needs and deliver tailored solutions that precisely meet your demands.</p>
                                <div className="footer-social">
                                    <ul className="social">
                                        <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                                        <li><a href="#"><i className="fab fa-twitter"></i></a></li>
                                        <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="footer-widget">
                                <h4 className="footer-widget-title">Useful Links</h4>

                                <div className="widget-link">
                                    <ul className="link">
                                        <li><Link to="/about">About Company</Link></li>
                                        <li><Link to="/service">Services</Link></li>
                                        <li><Link to="/contact">Contact</Link></li>
                                        <li><Link to="/blog">Blog</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-lg-3 col-sm-6">
                            <div className="footer-widget">
                                <h4 className="footer-widget-title">Contact Information</h4>

                                <div className="widget-info">
                                    <ul>
                                        <li>
                                            <div className="info-icon">
                                                <i className="flaticon-phone-call"></i>
                                            </div>
                                            <div className="info-text">
                                                <span><Link to="tel:+2349038224320">(+234) 903 822 4320</Link></span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="info-icon">
                                                <i className="far fa-envelope-open"></i>
                                            </div>
                                            <div className="info-text">
                                                <span><Link to="mailto:info@themichaelstech.com">info@themichaelstech.com</Link></span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="info-icon">
                                                <i className="flaticon-pin"></i>
                                            </div>
                                            <div className="info-text">
                                                <span>Bonny Island, Rivers State, Nigeria.</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-copyright-area">
                <div className="container">
                    <div className="footer-copyright-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <div className="copyright-text text-center">
                                    <p>© Copyrights { date.getFullYear() } TMT All rights reserved. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="progress-wrap">
            <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
            </svg>
        </div>
        </div>
     );
}
 
export default Footer;